var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 11.6641V8.33073C18.3333 5.18803 18.3333 3.61668 17.3569 2.64037C16.3806 1.66406 14.8093 1.66406 11.6666 1.66406H9.99992C6.85722 1.66406 5.28587 1.66406 4.30956 2.64037C3.33325 3.61668 3.33325 5.18803 3.33325 8.33073V11.6641C3.33325 14.8068 3.33325 16.3781 4.30956 17.3544C5.28587 18.3307 6.85722 18.3307 9.99992 18.3307H11.6666C14.8093 18.3307 16.3806 18.3307 17.3569 17.3544C18.3333 16.3781 18.3333 14.8068 18.3333 11.6641Z",
    stroke: "#2177FE",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82151 8.32552H12.6787C13.5766 8.32552 14.0255 8.32552 14.3045 8.08144C14.5834 7.83737 14.5834 7.44453 14.5834 6.65885C14.5834 5.87318 14.5834 5.48034 14.3045 5.23627C14.0255 4.99219 13.5766 4.99219 12.6787 4.99219H9.82151C8.9236 4.99219 8.47464 4.99219 8.19569 5.23627C7.91675 5.48034 7.91675 5.87318 7.91675 6.65885C7.91675 7.44453 7.91675 7.83737 8.19569 8.08144C8.47464 8.32552 8.9236 8.32552 9.82151 8.32552Z",
    stroke: "#2177FE",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 4.99219L1.66675 4.99219M4.16675 9.99219H1.66675M4.16675 14.9922H1.66675",
    stroke: "#2177FE",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/noteIcon.7d74681dc3aa4028af0ff524e2ad7ff2.svg";
export { ForwardRef as ReactComponent };